import SampleReport from "./SampleReport";
export default SampleReport;
